const ProductGroupService = function ProductGroupService(restangular, $q, settings, sortByKeys) {
    this._productGroupRoute = restangular.one('ProductGroup');
    this.selectedGroup = undefined;
    this.settings = settings;
    this.sortByKeys = sortByKeys;
    this.$q = $q;

    this.items = [];
    this._groupCache = {};
};

ProductGroupService.prototype.selectProductGroup = function (id) {
    if (!(id in this._groupCache)) {
        this._groupCache[id] = this._productGroupRoute.one(id).get();
    }

    this.productGroupPromise = this._groupCache[id].then((response) => {
        this.selectedGroup = response;
        return response;
    });

    return this.productGroupPromise;
};

ProductGroupService.prototype.getSelectedProductGroup = function () {
    return this.productGroupPromise
        ? this.productGroupPromise
        : this.$q.when({});
};

ProductGroupService.prototype.listForVisualShopping = function () {
    return this._productGroupRoute.one('ListForVisualShopping').get().then((items) => {
        this.items = items;
        return items;
    });
};

function createArgs(args) {
    return {
        pageNumber: args.pageNumber,
        pageSize: args.pageSize || 10,
        sortType: args.sortType,
    };
}

ProductGroupService.prototype.getProducts = function (args) {
    this.selectedGroupTotalCount = undefined;
    return this._productGroupRoute.one('Products').one(this.selectedGroup.Url).get(createArgs(args))
        .then((response) => {
            this.selectedGroupTotalCount = response.TotalRecordCount;
            return {
                items: response.Items,
                totalRecordCount: response.TotalRecordCount,
            };
        });
};

ProductGroupService.prototype.isGroupEligibleForRanking = function () {
    return !!(this.selectedGroup && this.selectedGroup.IsEligibleForRanking);
};

ProductGroupService.prototype.getSortOptions = function () {
    const sortGroup = this.isGroupEligibleForRanking()
        ? 'productGroup'
        : 'browse';

    return {
        sortTypes: this.settings[sortGroup].sortOptions,
        sortContext: this.sortByKeys.PRODUCT_GROUPS_KEY,
    };
};

module.exports = ProductGroupService;



// WEBPACK FOOTER //
// ./src/common/productgroup/productgroup.service.js